import { MEDALS_START_DATE } from "@dailywars/core/medals";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "#/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "#/components/ui/toggle-group";
import { formatCalendarMonthLabel } from "#/server/game/archiveCalendarMonth";

export const HISCORES_START_MONTH = MEDALS_START_DATE.slice(0, 7);

export function HiscoresScopeToggle({
  scope,
  onScopeChange,
}: {
  scope: "alltime" | "monthly";
  onScopeChange: (scope: "alltime" | "monthly") => void;
}) {
  return (
    <ToggleGroup
      value={[scope]}
      onValueChange={(value) => {
        const next = value[0];
        if (next === "alltime" || next === "monthly") {
          onScopeChange(next);
        }
      }}
      variant="outline"
      spacing={0}
    >
      <ToggleGroupItem value="alltime">All-time</ToggleGroupItem>
      <ToggleGroupItem value="monthly">Monthly</ToggleGroupItem>
    </ToggleGroup>
  );
}

export function HiscoresMonthNav({
  monthKey,
  onMonthChange,
  latestMonthKey,
}: {
  monthKey: string;
  onMonthChange: (monthKey: string) => void;
  latestMonthKey: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="icon"
        aria-label="Previous month"
        disabled={monthKey <= HISCORES_START_MONTH}
        onClick={() => onMonthChange(shiftMonthKey(monthKey, -1))}
      >
        <ChevronLeft />
      </Button>
      <span className="min-w-36 text-center text-sm font-medium">
        {formatCalendarMonthLabel(monthKey)}
      </span>
      <Button
        variant="outline"
        size="icon"
        aria-label="Next month"
        disabled={monthKey >= latestMonthKey}
        onClick={() => onMonthChange(shiftMonthKey(monthKey, 1))}
      >
        <ChevronRight />
      </Button>
    </div>
  );
}

function shiftMonthKey(monthKey: string, delta: number): string {
  const year = Number(monthKey.slice(0, 4));
  const monthIndex = Number(monthKey.slice(5, 7)) - 1;
  const shifted = new Date(Date.UTC(year, monthIndex + delta, 1));
  return shifted.toISOString().slice(0, 7);
}
